module.exports = __webpack_public_path__ + "img/f055e5d.png";